// extracted by mini-css-extract-plugin
export default {"container":"SupplierClientThumbnail_container__tGyNd","wrapper":"SupplierClientThumbnail_wrapper__6cMIx","detailsWrapper":"SupplierClientThumbnail_detailsWrapper__anl7s"};